import type { NextAuthConfig } from "next-auth"
import { jwtDecode } from "jwt-decode";
import CredentialsProvider from 'next-auth/providers/credentials';

const KEYCLOAK_SERVER_URL = process.env.KEYCLOAK_CLIENT_URL;
const KEYCLOAK_URL = `${KEYCLOAK_SERVER_URL}/protocol/openid-connect/token`;
const CLIENT_ID = "logueoBack";
const GRANT_TYPE = "password";

export default {
    pages: {
        signIn: '/auth/login',
        signOut: '/auth/login',
        error: '/auth/error',
    },
    trustHost: true,
    providers: [
        CredentialsProvider({
            async authorize(credentials) {
                if (!credentials) {
                    return null;
                }
                const formDetails = {
                    client_id: `${CLIENT_ID}`,
                    grant_type: `${GRANT_TYPE}`,
                    username: `${credentials.username}`,
                    password: `${credentials.password}`,
                };
                const formBody = new URLSearchParams(formDetails).toString();
                try {
                    const response = await fetch(KEYCLOAK_URL, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: formBody,
                    });

                    const data = await response.json();

                    if (!response.ok) {
                        throw new Error(`Error en la autenticación: ${data.error_description || response.statusText}`);
                    }
                    const decodedToken: any = jwtDecode(data.access_token);

                    const roles = decodedToken.realm_access.roles;

                    const expiresAt = new Date();
                    expiresAt.setSeconds(expiresAt.getSeconds() + data.expires_in);

                    const user = {
                        name: `${credentials.username}`,
                        email: decodedToken.email,
                        accessToken: `${data?.access_token}`,
                        refreshToken: data.refresh_token,
                        accessTokenExpires: Date.now() + data.expires_in * 1000,
                        id: decodedToken.id_usuario,
                        empresa: decodedToken.empresa,
                        roles: roles,
                        identificador: decodedToken.identificador ?? '',
                    };
                    return user;
                } catch (error) {
                    console.error("Error al autenticar con Keycloak:", error);
                    return null;
                }
            }

        },),
    ],
} satisfies NextAuthConfig


